import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Card';
import { showToast } from '../../plugins/toastUtils';

function AddHoliday({ api }) {

    const [title, setTitle] = useState('');
    const [date, setDate] = useState('');
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const AddHoliday = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const isValid = form.checkValidity();
        setValidated(true);
        if (isValid) {
            setLoading(true);
            await api.post(`/addHoliday`, {
                holiday_name: title,
                holiday_date: date,
            }).then((response) => {
                if (response.data.status === false) {
                    navigate('/403')
                }
                navigate('/holiday');
                setTimeout(() => {
                    showToast(response.data.message, "success", 'success');
                }, 100)
            }).catch((error) => {
                if (error.response.status == 403) {
                    navigate("/403");
                  }
                showToast(error.response.data.errors, 'error');
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12" lg="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Create Holiday</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Form onSubmit={e => AddHoliday(e)} noValidate validated={validated}>
                                    <Row>
                                        <Col sm="12" lg="6">
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="role">Holiday Title<span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type="text" id="title" onChange={e => setTitle(e.target.value)} required />
                                                <Form.Control.Feedback type="invalid">
                                                    This field is required
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="12" lg="6">
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="task_description">Date<span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type="date" id="date" onChange={e => setDate(e.target.value)} required />
                                                <Form.Control.Feedback type="invalid">
                                                    This field is required
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="12" lg="6">
                                            <Button type="submit" variant="btn btn-primary me-2" disabled={loading}>
                                                {loading ? 'Submitting...' : 'Submit'}
                                            </Button>
                                            <Button type="button" variant="btn btn-danger" onClick={() => navigate('/holiday')}>Cancel</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default AddHoliday;
